import { render } from "./ThankSection.vue?vue&type=template&id=17aa4184&scoped=true"
import script from "./ThankSection.vue?vue&type=script&lang=js"
export * from "./ThankSection.vue?vue&type=script&lang=js"

import "./ThankSection.vue?vue&type=style&index=0&id=17aa4184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17aa4184"]])

export default __exports__